module.exports = __webpack_public_path__ + "assets/img/login_icon5.f3807bb2.png";